import { Badge } from "@/components/ui/badge";
import {
  LayoutDashboard,
  MessageSquare,
  GraduationCap,
  Users,
  BarChart3,
  Brain,
} from "lucide-react";

const features = [
  {
    icon: LayoutDashboard,
    title: "Full-Stack CRM",
    description:
      "Leads, pipelines, deals, and contacts - all in one place. No more bouncing between 4 different apps.",
    ai: false,
  },
  {
    icon: MessageSquare,
    title: "AI Chatbots",
    description:
      "Train AI on your scripts and playbooks. Reps get instant answers instead of waiting for a manager.",
    ai: true,
  },
  {
    icon: GraduationCap,
    title: "AI Sales Coach",
    description:
      "Real-time coaching, objection handling, and role-play scenarios powered by AI. New reps ramp faster.",
    ai: true,
  },
  {
    icon: Users,
    title: "Recruiting CRM",
    description:
      "Pipeline candidates from first contact to first knock. Track every stage, automate follow-ups.",
    ai: false,
  },
  {
    icon: BarChart3,
    title: "Live Analytics",
    description:
      "Real-time dashboards so you know who's closing and who's coasting. No more end-of-week surprises.",
    ai: false,
  },
  {
    icon: Brain,
    title: "AI Leadership Tools",
    description:
      "Automate follow-ups, training reminders, 1-on-1 agendas, and performance reviews. Manage at scale.",
    ai: true,
  },
];

export default function FeaturesGrid() {
  return (
    <section id="features" className="py-28 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Everything Your Sales Team Needs.{" "}
            <span className="text-[#3b82f6]">Supercharged with AI.</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Built by sales leaders, for sales leaders.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                className="group relative rounded-xl border bg-card p-6 transition-all duration-200 hover:shadow-md hover:border-[#3b82f6]/20"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#3b82f6]/10">
                    <Icon className="h-5 w-5 text-[#3b82f6]" />
                  </div>
                  {f.ai && (
                    <Badge
                      variant="outline"
                      className="text-[10px] font-semibold tracking-wider uppercase border-[#3b82f6]/30 text-[#3b82f6] px-2 py-0.5"
                    >
                      AI
                    </Badge>
                  )}
                </div>
                <h3 className="font-semibold text-base mb-2">{f.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {f.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
